module.exports = __webpack_public_path__ + "img/coastserv_logo.f6d959ed.png";